module.exports = __webpack_public_path__ + "static/UNITY-TOWER-2nd-floor-traditional_v2-b42e5061b5691bcfadc783f2d4960e25.pdf";